export interface State {
  displaySearch: boolean;
  displayAddButton: boolean;
  displayMenu: boolean;
  searchTerm: string;
}

export enum OptionsActionTypes {
  SET_DISPLAY_ADD_BUTTON = 'SET_DISPLAY_ADD_BUTTON',
  SET_DISPLAY_SEARCH = 'SET_DISPLAY_SEARCH',
  SET_SEARCH_TERM = 'SET_SEARCH_TERM',
  SET_DISPLAY_MENU = 'SET_DISPLAY_MENU',
}
